import React, { useEffect, useState } from 'react';
import HomePage from './Pages/HomePage/HomePage';
import Helmet from 'react-helmet';
import './EnviziPriceEstimator.scss';
import { getDataSource } from '../utility';
import AppProvider from '../hooks/AppProvider';
import BusinessPartner from 'src/common/components/BusinessPartner/BusinessPartner';
import { useBPName } from 'src/common/hooks/widgets/useBPName';
import { UT30Envzi, tileInfo } from '../constant/spread';
import { swapCountryAndLanguage } from 'src/common/utils/swapCountryAndLanguage';
import { IBMLocale } from 'src/common/locale/mapValidLocale';
import { shortcode } from '../EnviziPriceEstimator.widget';

export interface EnviziPriceEstimatorProps {
  langCode: string;
  element: Element;
  countryToTest: string;
  test: boolean;
}

const EnviziPriceEstimator = ({
  langCode,
  element,
  countryToTest,
  test,
}: EnviziPriceEstimatorProps) => {
  const source =
    window.localStorage.getItem('debugSource') ?? getDataSource(element);
  const { bpName, logo, desc } = useBPName(UT30Envzi, true);
  const [tileValueSelected, setTileValueSelected] = useState(tileInfo.est);
  const localeCode = swapCountryAndLanguage(langCode as IBMLocale);
  useEffect(() => {
    if (localeCode.includes('ar')) {
      document.documentElement.dir = 'rtl';
    } else {
      document.documentElement.dir = 'ltr';
    }
  }, [localeCode]);
  return (
    <AppProvider source={source}>
      <div className="envizi_widget widget-styles">
        <Helmet>
          <script
            type="application/javascript"
            src={`https://www.ibm.com/account/ibmidutil/widget/js/loader.js`}
          ></script>
          <script
            type="application/javascript"
            src={`https://www.ibm.com/account/ibmidutil/widget/js/main.js`}
          ></script>
        </Helmet>
        {bpName ? (
          <BusinessPartner bpName={bpName} logo={logo} desc={desc} />
        ) : null}
        <HomePage
          tileValue={tileValueSelected}
          setTileValue={setTileValueSelected}
          langCode={langCode}
          test={test}
          countryToTest={countryToTest}
          shortcode={shortcode}
        />
      </div>
    </AppProvider>
  );
};

export default EnviziPriceEstimator;
